import { ListOfTimeModelResponse } from './Api/ListOfTimeModelResponse';

export class TimemodelEntity extends ListOfTimeModelResponse {
	public static tryCast(o: any): TimemodelEntity {
		const ret = new TimemodelEntity();
		return Object.assign(ret, o);
	}
}
